"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUESSpecialityTranslationsEN = getUESSpecialityTranslationsEN;
exports.getNewPESRollUpSpecialityTranslationsEN = getNewPESRollUpSpecialityTranslationsEN;
exports.getUesAoeTranslationsEN = getUesAoeTranslationsEN;
exports.getEnglishModule = getEnglishModule;
exports.getModuleOrDefault = getModuleOrDefault;
exports.getCurrentLocale = getCurrentLocale;
exports.getDynamicContentLocale = getDynamicContentLocale;
var node_fetch_1 = __importDefault(require("node-fetch"));
// Added for the native app, Metro doesn't support dynamic requires
function getUESSpecialityTranslationsEN() {
    return require("../data/en/uesSpecialityTranslations.json");
}
function getNewPESRollUpSpecialityTranslationsEN() {
    return require("../data/en/newPesRollUpSpecialityTranslations.json");
}
function getUesAoeTranslationsEN() {
    return require("../data/en/uesAoeTranslation.json");
}
function getEnglishModule(fileName) {
    return require("../data/en/".concat(fileName, ".json"));
}
// Module-scoped cache so a fetched translation file is reused for the lifetime
// of the process instead of being re-downloaded on every call. (Previously this
// map was declared inside getModuleOrDefault, which reset it on every call and
// made the cache a no-op.)
var CACHED_JSON = {};
function getModuleOrDefault(localeCode, fileName) {
    return __awaiter(this, void 0, void 0, function () {
        var url, response, data, filteredData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 6]);
                    url = "https://lagoon-web-psx.uhc.com/specialty/dev/".concat(localeCode, "/").concat(fileName, ".json");
                    if (CACHED_JSON[url] != null) {
                        return [2 /*return*/, CACHED_JSON[url]];
                    }
                    return [4 /*yield*/, (0, node_fetch_1.default)(url)];
                case 1:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 2:
                    data = _a.sent();
                    if (data && data.globallink) {
                        filteredData = Object.fromEntries(Object.entries(data).filter(function (_a) {
                            var key = _a[0];
                            return key !== "globallink";
                        }));
                        CACHED_JSON[url] = filteredData;
                        return [2 /*return*/, filteredData];
                    }
                    CACHED_JSON[url] = data;
                    return [2 /*return*/, data];
                case 3:
                    error_1 = _a.sent();
                    if (!((error_1 === null || error_1 === void 0 ? void 0 : error_1.code) === "MODULE_NOT_FOUND")) return [3 /*break*/, 5];
                    return [4 /*yield*/, getModuleOrDefault("en", fileName)];
                case 4: return [2 /*return*/, _a.sent()];
                case 5: throw error_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
/**
 * Get the current two-character locale (e.g. 'en' or 'es')
 */
function getCurrentLocale(locale) {
    if (locale === void 0) { locale = "en"; }
    return locale.slice(0, 2);
}
/**
 * Get the current locale with fallback to 'en'.
 * @description
 * Since we currently only have english and spanish files for dynamic content,
 * we should default to english so content will still appear for users with other locales set
 */
function getDynamicContentLocale(locale) {
    var localeCode = getCurrentLocale(locale);
    if (["en", "es", "my", "ht", "ic", "ko", "vi", "zh"].includes(localeCode)) {
        return localeCode;
    }
    return "en";
}
// All translation files loaded for a locale. Used to warm the cache
// concurrently so a cold load does not run ~40 fetches sequentially.
var TRANSLATION_FILES = [
    "accessibilityTranslations",
    "accreditationTranslations",
    "ageTranslations",
    "aoeTranslations",
    "uesAoeTranslation",
    "behaviouralProgramsTranslations",
    "culturalCompetencyTranslations",
    "culturalCompetencyCategoriesTranslations",
    "carePathCategoryTranslations",
    "degreeTranslations",
    "ethnicityTranslations",
    "hcbsWaiversTranslations",
    "raceTranslations",
    "behavioralFacilityProgramsTranslations",
    "platinumProgramsTranslations",
    "facilityServiceCodeTranslations",
    "facilitySubCategoryCodeTranslations",
    "genderTranslations",
    "languageTranslations",
    "preferredFacilityTranslations",
    "pesSpecialityTranslations",
    "pesFacilityTranslations",
    "qualityRatingTranslations",
    "leapFrogRatingCategories",
    "sourceSystemSpecialityTranslations",
    "servicesOfferedTranslations",
    "accommodateOfferedTranslations",
    "methodsOfServiceTranslations",
    "uesSpecialityTranslations",
    "newPesRollUpSpecialityTranslations",
    "virtualCareTranslations",
    "virtualCareOptionsTranslations",
    "virtualCareProviderSearchTranslations",
    "ddpTranslations",
    "costExperienceCarePathsTranslations",
    "docAsapAvailabilityTranslations",
    "servicesProvidedTranslations",
    "licensedStatesTranslations",
];
function getDynamicContentPaths(locale) {
    return __awaiter(this, void 0, void 0, function () {
        var localeCode, entries, content;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    localeCode = getDynamicContentLocale(locale);
                    return [4 /*yield*/, Promise.all(TRANSLATION_FILES.map(function (fileName) { return __awaiter(_this, void 0, void 0, function () { var _a; return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = [fileName];
                                    return [4 /*yield*/, getModuleOrDefault(localeCode, fileName)];
                                case 1: return [2 /*return*/, _a.concat([_b.sent()])];
                            }
                        }); }); }))];
                case 1:
                    entries = _a.sent();
                    content = Object.fromEntries(entries);
                    return [2 /*return*/, {
                            accessibility: content.accessibilityTranslations,
                            accreditation: content.accreditationTranslations,
                            age: content.ageTranslations,
                            aoe: content.aoeTranslations,
                            aoeDetails: content.uesAoeTranslation,
                            behaviouralPrograms: content.behaviouralProgramsTranslations,
                            culturalCompetency: content.culturalCompetencyTranslations,
                            culturalCompetencyCategories: content.culturalCompetencyCategoriesTranslations,
                            carePathCategory: content.carePathCategoryTranslations,
                            degree: content.degreeTranslations,
                            ethnicityCode: content.ethnicityTranslations,
                            hcbsWaivers: content.hcbsWaiversTranslations,
                            raceCode: content.raceTranslations,
                            behavioralFacilityPrograms: content.behavioralFacilityProgramsTranslations,
                            platinumPrograms: content.platinumProgramsTranslations,
                            facilityServiceCode: content.facilityServiceCodeTranslations,
                            facilitySubCategoryCode: content.facilitySubCategoryCodeTranslations,
                            gender: content.genderTranslations,
                            language: content.languageTranslations,
                            preferredFacility: content.preferredFacilityTranslations,
                            pesSpecialty: content.pesSpecialityTranslations,
                            pesFacility: content.pesFacilityTranslations,
                            qualityRating: content.qualityRatingTranslations,
                            leapFrogRatings: content.leapFrogRatingCategories,
                            sourceSystemSpecialty: content.sourceSystemSpecialityTranslations,
                            servicesOffered: content.servicesOfferedTranslations,
                            accommodateOffered: content.accommodateOfferedTranslations,
                            methodsOfService: content.methodsOfServiceTranslations,
                            uesSpecialty: content.uesSpecialityTranslations,
                            newPesRollUpSpecialty: content.newPesRollUpSpecialityTranslations,
                            virtualCare: content.virtualCareTranslations,
                            virtualCareOptions: content.virtualCareOptionsTranslations,
                            virtualCareProviderSearch: content.virtualCareProviderSearchTranslations,
                            ddp: content.ddpTranslations,
                            carePathSteps: content.costExperienceCarePathsTranslations,
                            docAsapAvailability: content.docAsapAvailabilityTranslations,
                            servicesProvided: content.servicesProvidedTranslations,
                            uesAoe: content.uesAoeTranslation,
                            licensedStates: content.licensedStatesTranslations,
                        }];
            }
        });
    });
}
exports.default = getDynamicContentPaths;
